import { NgModule } from "@angular/core";
import { SafeUrlPipe } from "./safe-url.pipe";
import { PricePipe } from "./price.pipe";
import { TruncatePipe } from "@deltager/organizers/admin/shared/pipes/truncate.pipe";
import { DayDateFormatPipe } from "@deltager/organizers/admin/shared/pipes/day-format-date.pipe";
import { FormattedFileSizePipe } from "@deltager/organizers/admin/shared/pipes/format-file-size.pipe";
import { DayTimeFromSeconds } from "@deltager/organizers/admin/shared/pipes/day-format-seconds.pipe";
import { DayTimeFormatPipe } from "./day-format-time.pipe";

@NgModule({
  declarations: [
    SafeUrlPipe,
    PricePipe,
    TruncatePipe,
    DayDateFormatPipe,
    FormattedFileSizePipe,
    DayTimeFromSeconds,
    DayTimeFormatPipe
  ],
  exports: [
    SafeUrlPipe,
    PricePipe,
    DayDateFormatPipe,
    FormattedFileSizePipe,
    DayTimeFromSeconds,
    TruncatePipe,
    DayTimeFormatPipe
  ],
  providers: [DayDateFormatPipe],
})
export class PipesModule {}
